import React, { useState } from "react";
import "./Value.css"; // Import the CSS file

const Value = () => {
  const [openIndex, setOpenIndex] = useState(0);

  const toggleAccordion = (index) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  const values = [
    {
      title: "نحن نؤمن بالأخلاق - نتصرف بصدق ومسؤولية",
      content:
        "نعمل بصدق ونزاهة لبناء الثقة وتعزيز علاقات شاملة ومسؤولة ودائمة. ممارسات العمل الأخلاقية هي التي توجه أعمالنا، وتحدد هويتنا وسلوكنا.",
    },
    {
      title: "منع الأسعار غير المستقرة",
      content: "نحن نضمن أن تقلبات الأسعار لا تؤثر على أموالك.",
    },
    {
      title: "أفضل سعر في السوق",
      content:
        "استراتيجية التسعير التنافسية لدينا تضمن لك أفضل الصفقات.",
    },
  ];

  return (
    <div className="value-section">
      {/* Left Image Section */}
      <div className="value-image">
        <img src="https://akari.sa/wp-content/uploads/2024/08/cropped-cropped-cropped-%D8%B9%D9%82%D8%A7%D8%B1%D9%8A-1-1.webp" alt="Modern House" />
      </div>

      {/* Right Content Section */}
      <div className="value-content">
        <h3 className="value-subtitle">قيمتنا</h3>
        <h2 className="value-title">القيمة التي نقدمها لك</h2>
        <p className="value-description">
        نحن دائمًا على أتم الاستعداد لمساعدتك بتقديم أفضل الخدمات لك. نؤمن بأن مكانًا جيدًا للعيش يُحسّن حياتك.
        </p>

        {/* Accordion Section */}
        <div className="accordion">
          {values.map((item, index) => (
            <div
              key={index}
              className={`accordion-item ${openIndex === index ? "open" : ""}`}
            >
              <button
                className="accordion-header"
                onClick={() => toggleAccordion(index)}
              >
                {item.title}
                <span>{openIndex === index ? "▲" : "▼"}</span>
              </button>
              {openIndex === index && (
                <p className="accordion-content">{item.content}</p>
              )}
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default Value;



